export function ChevronDown ({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#clip0_156_6104)'>
        <path
          d='M0.160812 3.39552C0.400645 3.1326 0.821563 3.10241 1.10092 3.32811L6.09311 7.36251L10.8893 3.33608C11.164 3.10544 11.5856 3.12787 11.8307 3.38632C12.0758 3.64487 12.052 4.04166 11.7774 4.27237L6.54559 8.66462C6.29636 8.87378 5.92138 8.87726 5.66798 8.67258L0.232426 4.28034C-0.0469143 4.05461 -0.0789952 3.65844 0.160812 3.39552Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_156_6104'>
          <rect width='12' height='12' fill='white' />
        </clipPath>
      </defs>
    </svg>

  )
}

export function ChevronRight ({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#clip0_227_8173)'>
        <path
          d='M5.65866 0.26802C5.22047 0.667741 5.17015 1.36927 5.54633 1.83486L12.2703 10.1552L5.5596 18.1489C5.1752 18.6067 5.21259 19.3094 5.64335 19.7179C6.07425 20.1263 6.73558 20.0866 7.12009 19.6289L14.4405 10.9093C14.7891 10.4939 14.7949 9.86897 14.4538 9.44663L7.13337 0.387377C6.75715 -0.0781904 6.09688 -0.131659 5.65866 0.26802Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_227_8173'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function ChevronLeft ({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#clip0_227_8168)'>
        <path
          d='M14.3413 19.732C14.7795 19.3323 14.8298 18.6307 14.4537 18.1651L7.72968 9.84482L14.4404 1.8511C14.8248 1.39327 14.7874 0.690624 14.3567 0.282087C13.9257 -0.126331 13.2644 -0.0866012 12.8799 0.371063L5.5595 9.09069C5.2109 9.50608 5.2051 10.131 5.54622 10.5534L12.8666 19.6126C13.2428 20.0782 13.9031 20.1317 14.3413 19.732Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_227_8168'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export function ChevronUp ({ className }: { className?: string }): JSX.Element {
  return (
    <svg
      width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <g clipPath='url(#clip0_2591_512667)'>
        <path
          d='M0.214416 11.473C0.534193 11.8235 1.09542 11.8638 1.46789 11.5628L8.12415 6.18365L14.5191 11.5522C14.8854 11.8597 15.4475 11.8298 15.7743 11.4852C16.1011 11.1405 16.0693 10.6114 15.7031 10.3038L8.72745 4.4475C8.39514 4.16862 7.89517 4.16399 7.55731 4.43688L0.309902 10.2932C-0.0625524 10.5942 -0.105327 11.1224 0.214416 11.473Z'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='clip0_2591_512667'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>

  )
}
